import { RootState } from '@/redux/store'
import { useSelector } from 'react-redux'

export const useTeamName = (teamId: number | null) => {
  const { teams } = useSelector((state: RootState) => state.team)
  if (!teamId) return null
  const team = teams.find((t) => t.id === teamId)
  return team?.name || `Team ${teamId}`
}
